import React from 'react';
import orderBy from 'lodash/orderBy';

import MuiTable from '@material-ui/core/Table';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import TrackTableRow from './track-table-row';
function TrackTable({ release, isDelivered, releaseChanged }) {
  const { tracks } = release;

  return (
    <MuiTable size="small" aria-label="release tracks">
      <MuiTableHead>
        <MuiTableRow>
          <MuiTableCell style={{ width: '5%' }}>id</MuiTableCell>
          <MuiTableCell style={{ width: '5%' }}>#</MuiTableCell>
          <MuiTableCell style={{ width: '15%' }}>ISRC</MuiTableCell>
          <MuiTableCell style={{ width: '20%' }}>Track Title</MuiTableCell>
          <MuiTableCell style={{ width: '20%' }}>Track Artists</MuiTableCell>
        </MuiTableRow>
      </MuiTableHead>
      <MuiTableBody>
        {orderBy(tracks, ['sequence', 'id'], ['asc', 'asc']).map(row => (
          <TrackTableRow row={row} idDelivered={isDelivered} key={row.id} rowChanged={releaseChanged} />
        ))}
      </MuiTableBody>
    </MuiTable>
  );
}
export default TrackTable;
